const headerNavLinks = [
  { href: '/', title: 'Home' },
  { href: '/blog', title: 'Blog' },
  { href: '/chi-siamo', title: 'Chi siamo' },
  { href: '/digitalizza-il-tuo-menu', title: 'Digitalizza il tuo menu' },
  // { href: '/tags', title: 'Tags' },
]

export default headerNavLinks
